export const executeRecaptcha = async (action) => {
  return new Promise((resolve, reject) => {
    if (typeof window.grecaptcha === 'undefined') {
      console.warn('reCAPTCHA not loaded, skipping verification');
      resolve(null);
      return;
    }

    const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
    if (!siteKey) {
      console.warn('reCAPTCHA site key not configured');
      resolve(null);
      return;
    }

    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(siteKey, { action })
        .then(resolve)
        .catch((error) => {
          console.error('reCAPTCHA error:', error);
          reject(error);
        });
    });
  });
};
